import React from 'react';

import {
    FilaPacienteStyled,
    NombrePaciente,
    TextoPaciente,
    EtiquetaServicio,
    BotonArchivar
} from '../../Css/StyledListadoPacientes';


export const FilaPaciente = ({
    paciente,
    indice,
    archivado,
    onSeleccionar,
    onArchivar,
    onRestaurar
}) => {


    const manejarAccionArchivo = (e) => {

        // Evitamos que el click del botón también abra
        // la ficha completa del paciente.
        e.stopPropagation();

        if (archivado) {
            onRestaurar(paciente);
            return;
        }

        onArchivar(paciente);
    };


    return (
        <FilaPacienteStyled
            indice={indice}
            servicio={paciente.servicio}
            onClick={() => onSeleccionar(paciente)}
        >

            <NombrePaciente>
                {paciente.apellido}, {paciente.nombre}
            </NombrePaciente>


            <div className="columna-servicio">
                <EtiquetaServicio servicio={paciente.servicio}>
                    {paciente.servicio}
                </EtiquetaServicio>
            </div>


            <TextoPaciente className="columna-cobertura">
                {paciente.cobertura_medica || '—'}
            </TextoPaciente>


            <TextoPaciente>
                {paciente.edad} a {paciente.mes} m
            </TextoPaciente>


            <BotonArchivar
                type="button"
                restaurar={archivado}
                title={
                    archivado
                        ? 'Restaurar paciente'
                        : 'Archivar paciente'
                }
                onClick={manejarAccionArchivo}
            >
                {archivado ? (

                    <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    >
                        <path
                            d="M3 11a9 9 0 1 1 2.6 6.3"
                            strokeLinecap="round"
                        />
                        <path
                            d="M3 6v5h5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>

                ) : (

                    <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    >
                        <rect
                            x="3.5"
                            y="4.5"
                            width="17"
                            height="4.5"
                            rx="1.2"
                        />

                        <path
                            d="M4.5 9v8.5a1.8 1.8 0 0 0 1.8 1.8h11.4a1.8 1.8 0 0 0 1.8-1.8V9"
                            strokeLinejoin="round"
                        />

                        <path
                            d="M10 13h4"
                            strokeLinecap="round"
                        />
                    </svg>
                )}
            </BotonArchivar>

        </FilaPacienteStyled>
    );
};